module.exports = __webpack_public_path__ + "static/media/pf26.8e624602.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/pf26.png
// module id = 1066
// module chunks = 0